import { REGISTER } from './types';
export const getAccountStatus = () => {
  return {
    type: REGISTER.GET_ACCOUNT_STATUS,
  };
};

export const getAccountStatusSuccess = (response) => {
  return {
    type: REGISTER.GET_ACCOUNT_STATUS_SUCCESS,
    accountStatus: response,
  };
};

export const getAccountStatusFailure = (error) => ({
  type: REGISTER.GET_ACCOUNT_STATUS_FAILURE,
  error,
});

export const updateAccountStatus = (accountStatus) => ({
  type: REGISTER.UPDATE_ACCOUNT_STATUS,
  accountStatus,
});

export const updateError = (errorValue) => ({
  type: REGISTER.UPDATE_ERROR,
  errorValue,
});

export const updateRegisterFieldValue = (fieldValue) => ({
  type: REGISTER.UPDATE_FIELD_VALUE,
  fieldValue,
});

export const displayToast = (val) => ({
  type: REGISTER.DISPLAY_TOAST,
  val,
});

export const getFacilities = (ucmId) => {
  return {
    type: REGISTER.GET_FACILITIES,
    ucmId,
  };
};

export const getFacilitiesSuccess = (response) => {
  return {
    type: REGISTER.GET_FACILITIES_SUCCESS,
    facilities: response,
  };
};

export const getFacilitiesFailure = (error) => ({
  type: REGISTER.GET_FACILITIES_FAILURE,
  error,
});

export const updateAdminTerms = (payload) => ({
  type: REGISTER.UPDATE_ADMIN_TERMS,
  payload,
});

export const updateAdminTermsSuccess = (response) => ({
  type: REGISTER.UPDATE_ADMIN_TERMS_SUCCESS,
  response,
});

export const updateAdminTermsFailure = (error) => ({
  type: REGISTER.UPDATE_ADMIN_TERMS_FAILURE,
  error,
});
